import * as Api from "@api";
import * as C from "@components";
import React from 'react';
import { ProductSlider } from '../ProductCard/ProductSlider';
import { ProductsSectionContentKeys } from './Definitions';

export interface ProductSliderProps extends React.ComponentPropsWithoutRef<typeof ProductSlider>
{
    pageContent: Record<string, Api.ContentItem>;
    className?: string;
}

export const ProductsSection = ({ pageContent, products, variant, className }: ProductSliderProps): React.FunctionComponentElement<ProductSliderProps> =>    
{
    return (
        <C.PageSection className={className}>
            <C.PageContent {...pageContent["products.headline"]} centered typography={C.Typography.H4} margins={{ bottom: C.Margin.D40 }} />
            <ProductSlider products={products} variant={variant} />
        </C.PageSection>
    );
}